<!--
  画面名：-
  概要： フローダイアグラムから遷移した時に表示する店舗マニュアル一覧のコンポーネント
  備考： -
-->

<!-- HTML -->
<template>
  <!--  ページ全体を囲う要素  -->
  <div class="wrapper">
    <v-form ref="form">
      <!-- 店舗マニュアル表示エリア -->
      <table>
        <tbody>
          <tr v-if="(manualList.length === 0) && (filterItem.period === 0)">
            <!-- 表示する店舗マニュアルがなく、頻度指定が「全て」の場合の処理を記載 -->
            <td><span :class="{text:isOperation}">{{ language.MsgNotTargetManual }}</span></td>
          </tr>
          <tr v-else-if="(manualList.length === 0) && (filterItem.period === 1)">
            <!-- 表示する店舗マニュアルがなく、頻度指定が「都度」の場合の処理を記載 -->
            <td><span :class="{text:isOperation}">{{ language.MsgNoTargetManualsOfPeriodAnyTime }}</span></td>
          </tr>
          <!-- 店舗マニュアル項目 -->
          <tr v-else v-for="(list,index) of manualList" :key="index">
            <!-- ナンバーマーク -->
            <td class="mb-5 mark" :class="{vatop:!list.default}">
              <span class="number">{{index + 1}}</span>
            </td>
            <td v-if="!list.default && !isOperation" class="mb-5 manual-text">
              <!-- 店舗マニュアル名称 -->
              <v-flex>
                <v-select
                  v-model="list.selectManuals"
                  :items="allManuals"
                  item-text="label"
                  item-value="value"
                  outline
                  single-line
                  :rules="[rules.manualRule]"
                  @change="duplicateValidate"
                ></v-select>
              </v-flex>
            </td>
            <td v-else :class="[{'manual-text':!isOperation},{'operation-text':isOperation},'mb-5'] ">
              <!-- 店舗マニュアル名称 -->
              <span :class="{text:isOperation}">{{list.text}}</span>
            </td>
            <!-- 作業管理への遷移ボタン -->
            <td  v-if="isOperation" class="mb-5 operation-button">
              <div class="button" :style="{ 'border-image': 'url(' + buttonSvg + ') 10% fill / 10%' }" dark @click="submit(list)">
                <span class="text">{{language.LabelWorkManagement}}</span>
              </div>
            </td>
            <!-- 削除ボタン -->
            <td class="mb-5 flex xs12 sm3" v-if="!isList && !isOperation" :class="{vatop:!list.default}">
              <div class='remove-button-area'>
                <v-btn class="icon-btn" fab small color="#fff" @click="remove(index)">
                  <v-icon color="#1f4e9c">remove</v-icon>
                </v-btn>
              </div>
            </td>
          </tr>
          <tr class="w_100">
            <v-card-text class="card" v-if="!isList && !isOperation">
              <v-btn
                class="icon-btn addButton"
                absolute
                dark
                fab
                top
                small
                color="#1f4e9c"
                @click="add()"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </v-card-text>
          </tr>
        </tbody>
      </table>
    </v-form>
  </div>
</template>
<!-- /HTML -->

<script>
// 店舗マニュアル参照ボタンの画像
import ButtonSvg from '@/assets/images/button-large.svg'

export default {
  name: 'TemplateFlowDiagramManualList',
  props: {
    isList: { type: Boolean, default: false },
    isOperation: { type: Boolean, default: false },
    language: Object,
    configCheckList: { type: Object }
  },
  // 初期値設定
  data () {
    return {
      // チェックリストを格納
      manualList: [],
      // セレクトボックスの初期値
      selected: 1,
      isAdd: false,
      allManuals: [],
      isDisabled: true,
      list: 0,
      selectManuals: 0,
      validateMessage: '',
      rules: {
        // 重複チェック
        manualRule: value => (this.manualRules(value)) || this.validateMessage
      },
      checkManualList: [],
      checkCount: 0,
      // 変更前の店舗マニュアル情報格納
      oldManuals: [],
      // ボタン画像を格納
      buttonSvg: ButtonSvg,
      filterItem: {}
    }
  },
  watch: {
    // 保存ボタン表示非表示設定
    isDisabled () {
      this.$emit('setDisabled', this.isDisabled)
    },
    // チェックリストを監視
    manualList () {
      // 親に通達
      this.setManualList()
    }
  },
  // コンポーネントの処理を記載
  methods: {
    /**
     *  チェックリスト取得処理
     * @param {Array} manuals 表示するマニュアル情報
     * @param {Array} allManuals 追加用マニュアル情報
     * @param {Array} oldManuals 変更前の店舗マニュアル情報 一般衛生で使用
     * @param {Object} filterItem 前画面のドロップダウンリストで選択された頻度項目のオブジェクト
     */
    getData (data, allManuals, oldManuals, filterItem) {
      this.selectManuals = 0
      this.allManuals = allManuals
      this.oldManuals = oldManuals

      // ドロップダウンリストの選択内容の格納
      this.filterItem = filterItem

      // データ挿入
      if (data) {
        for (let list of data) {
          this.manualList.push({ text: list.label, default: true, selectManuals: list.value, s_id: list.s_id, m_id: list.m_id, title: list.title, workType: list.workType })
        }
      }
    },
    // 種別のバリデーション設定
    manualRules (value) {
      this.checkCount = 0
      // 初期表示選択時
      if (value === 0) {
        this.isDisabled = true
        return true
      }
      this.checkManualList = []

      // 表示されている店舗マニュアルIDをチェック
      for (let i = 0; i < this.manualList.length; i++) {
        this.checkManualList.push(this.manualList[i].selectManuals)
        if (value === this.manualList[i].selectManuals) {
          this.checkCount++
        }
      }

      // 2つ以上カウントされていたら重複
      if (this.checkCount >= 2) {
        // 重複あり
        this.isDisabled = true
        this.validateMessage = this.language.MsgFailedManualDuplicate
        return false
      }

      // 初期値が存在する時は保存ボタンは非活性
      if (this.checkManualList.indexOf(0) >= 0) {
        this.isDisabled = true
      }
      return true
    },
    // 店舗マニュアル情報を親に送信
    setManualList () {
      this.$emit('setManualList', this.manualList)
    },
    /**
     * 店舗マニュアル追加処理
     */
    add () {
      this.isAdd = true
      this.isDisabled = true
      this.manualList.push({ default: false, selectManuals: this.selectManuals })
    },
    /**
     * 店舗マニュアル削除処理
     */
    remove (index) {
      this.manualList.splice(index, 1)

      // 全体重複チェック
      this.duplicateValidate()
      // 設定前のマニュアルが存在しているかつ、表示されているマニュアルが存在しない場合⇒保存ボタン押下可能
      if (this.oldManuals.length > 0 && this.manualList.length < 1) {
        this.isDisabled = false
      }

      // 設定前のマニュアルが存在していないかつ、表示されているマニュアルが存在しない場合⇒保存ボタン押下不可
      if (this.oldManuals.length === 0 && this.manualList.length === 0) {
        this.isDisabled = true
      }
    },
    /**
     * ダイアログ閉じ際の処理
     */
    clear () {
      // コンポーネントのデータを初期化
      this.manualList = []
      // 種別初期化
      this.selected = 1
      this.isAdd = false
      this.isDisabled = true
    },
    // 全体重複チェック判定処理
    duplicateValidate () {
      // 重複チェックで問題ない場合は保存ボタンを表示（isDisabledをfalseにする）
      if (this.$refs.form.validate()) {
        this.isDisabled = false
        return
      }
      this.isDisabled = true
    },
    // 作業管理画面へ遷移
    submit (todo) {
      let workTypeName = this.getWorkTypeName(todo.workType)
      // 作業管理画面へ遷移
      this.$router.push({ name: 'WorkManagement', params: { m_id: todo.m_id, s_id: todo.s_id, title: todo.title, isFlowDiagram: true, workTypeName: workTypeName }, query: { restaurantId: this.$route.query.restaurantId } })
    },
    getWorkTypeName (workType) {
      let arrWorkType = this.configCheckList.WorkType

      // work_typeから個別入力項目名称の特定
      for (let i = 0; i < arrWorkType.length; i++) {
        if (arrWorkType[i].value === workType) {
          return arrWorkType[i].text
        }
      }
    }
  }
}
</script>

<!-- style読み込み -->
<style lang="scss" scoped>
  @import '@/assets/scss/systemConfig/templateFlowDiagramManualList.scss';
</style>
